import React from 'react';
import ReactDOM from 'react-dom/client'; // Asegúrate de que el cliente esté importado aquí
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Cambia createRoot a estar bajo ReactDOM.createRoot
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
